import React from 'react';
import { faDiagramProject } from '@fortawesome/pro-regular-svg-icons/faDiagramProject';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, projectSnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_PROJECTS_QUERY } from './queries';

const ProjectPicker: React.FC<{ element: DocumentElementType }> = ({
  element,
}) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_PROJECTS_QUERY}
    collectionField="documentElementProjects"
    icon={faDiagramProject}
    iconColour="#1f8a5b"
    defaults={{
      label: 'Project',
      placeholder: 'Search for a project...',
    }}
    rowSubtitle={(row) =>
      (row.customerName as string | null | undefined) || null
    }
    rowBadges={(row) => {
      const out: string[] = [];
      if (row.nameAbbr) out.push(String(row.nameAbbr));
      return out;
    }}
    rowToSnapshot={projectSnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.project].contextSpec}
  />
);

export default ProjectPicker;
